<template>
<div :ref="loadingobj">
    <div class="TTL-el-form-search-regular">
        <span class="TTL-title">编辑Banner</span>
        <div class="TTL-button TTL-btn-option">
            <wcbutton :option="{title:'提交数据'}" @finish="submitData"/>
        </div>
        <div class="TTL-button TTL-btn-option">
            <wcbutton :option="{title:'返回Banner管理',type:'del'}" @finish="$parent.JUMPVIEW({name:'Banner'})"/>
        </div>
    </div>

    <div>
        <div class="TTL-form-submit-box">
            <el-form :inline="false" style="margin-top:20px">
                <el-form-item>
                    <label class="TTL-form-label">广告图<i>*</i></label>
                    <wcupload :option="{size:'large', phototype:'system'}"
                        :value="param.url"
                        @finish="(val)=> {
                            param.url=val.url;
                        }"
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">广告名称<i>*</i></label>
                    <wcinput :option="{placeholder:'请输入广告名称',type:'input',clearable:true,ischange:true,isinput:true,width:'250px'}"
                        :value="param.name"
                        @finish="(val)=> {
                            if(val.type=='input' || val.type=='change') param.name=val.value;
                        }"
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">跳转类型</label>
                    <wcselect :option="{placeholder:'请选择跳转类型',filterable:true,ischange:true,width:'220px'}"
                        :value="param.type"
                        :list="typelist"
                        @finish="(val)=> {
                            if(val.type=='change') param.type=val.value;
                        }"
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">是否显示</label>
                    <div class="TTL-switch">
                        <el-switch v-model="param.isshow" :active-value="1" :inactive-value="0" />
                    </div>
                </el-form-item>
            </el-form>
        </div>
    </div>
</div>
</template>

<script>
import INTERFACE_BANNER from '@/Interface/Shop/banner';
export default {
    components:{},
    data() {
        return {
            loadingobj:'editbanner',
            param: {
                id:'',
                name:'',
                url:'',
                type:0,
                isshow:1,
            },
            typelist:[
                {id:0,name:'无跳转'},
                {id:1,name:'跳转宠物详情'},
            ],
        }
    },
    mounted() {
        this.OnloadMethod();
    },
    methods: {

        OnloadMethod() {

        },

        BrotherComponentIn(data) {
            var ids=data.param && data.param.ids ? data.param.ids : '';
            if(data.isask) {
                this.$confirm.confirm(
                    '当前有操作正在执行，是否要将其覆盖 ？',
                    '提示',
                    {confirmButtonText:'确定',cancelButtonText:'取消',type:'warning'}
                ).then(()=> {
                    this.GetBannerInfo(ids);
                }).catch(()=> {});
            }else if(data.reload) {

            }else {
                this.GetBannerInfo(ids);
            }
        },

        GetBannerInfo(ids) {
            if(!ids) return false;
            var obj=this.$refs[this.loadingobj];
            this.$loading.openloading(obj);
            INTERFACE_BANNER.GET_BANNER_INFO({ids:ids}).then((res) => {
                this.$loading.closeloading(obj);
                if(res.status > 0) return false;
                if(!res.data || res.data.length==0) return false;
                this.param=res.data[0];
            });
        },

        submitData() {
            if(!this.param.id) {this.$notice({title:'提交数据提示',message:'banner信息不存在',type:'warning'});return false;}
            if(!this.param.url) {this.$notice({title:'提交数据提示',message:'请上传banner图片',type:'warning'});return false;}
            if(!this.param.name) {this.$notice({title:'提交数据提示',message:'请输入广告名称',type:'warning'});return false;}

            var obj=this.$refs[this.loadingobj];
            this.$loading.openloading(obj);
            INTERFACE_BANNER.EDIT_BANNER(this.param).then((res) => {
                this.$loading.closeloading(obj);
                if(res.status > 0) return false;
                this.$notice({title:'成功提示',message:'修改数据成功',type:'success'});
                this.$parent.JUMPVIEW({name:'Banner',delname:'EditBanner'});
            });
        },

        ChangePageLabel() {

        },

    },
}
</script>
<style scoped>
.TTL-form-label i {font-style:normal;color:red;font-size:12px;font-weight:400;}
.TTL-btn-option {display:inline-block;margin-right:20px;}
</style>
